import React from "react";
import "./SummaryView.css";

export const SummaryView = ({ summaryData }) => {
  return (
    <div className="summary-view">
      <div className="summary-header">
        <h3>Summary of Expenses</h3>
      </div>
      {summaryData && summaryData.length > 0 && (
        <div className="summary-table-container">
          <table>
            <tbody>
              {summaryData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {row.map((cell, cellIndex) => (
                    <td
                      key={cellIndex}
                      className={`
                        ${rowIndex === 0 ? "header-cell" : ""}
                        ${
                          rowIndex === 0 ||
                          cellIndex === 0 ||
                          cell.includes("Grand Total")
                            ? "bold-cell"
                            : ""
                        }
                        ${cellIndex > 0 ? "right-align" : ""}
                      `}
                    >
                      {cellIndex > 0 && !isNaN(cell)
                        ? new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                          }).format(Number(cell))
                        : cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
